import React,{useState,useContext} from 'react'
import styled from 'styled-components'
import { CartContext } from '../../context/cart'
import minusIcon from '../../images/png/minus-big-symbol.png'
import plusIcon from '../../images/png/mais (1).png'

const CardWrapper = styled.div` 
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 0.9rem;
    width: 220px;
    height: 40px;
    margin-right: 0.3rem;
    border: 1px solid #858585;

    padding-left: 10px;
    font-family: "Poppins-Regular";

    @media screen and (max-width:920px){
        width: 100%;
        margin-bottom: 0.8rem;
    }

`

const Plus = styled.button`
    height: 40px;
    border: 1px solid #858585;
    background-color: white;

`
const Minus = styled.button`
    height: 40px;
    border: 1px solid #858585;
    background-color: white;

`
const Qtd = styled.button`
`
const Box = styled.div`
    position: absolute;
    right: 0;
    height: 40px;
    
`



const Quantity = () => {

    const {quantityCartProduct,setQuantityCartProduct} = useContext(CartContext)
    return(
        <CardWrapper>
            Quantidade: {quantityCartProduct}
            <Box>
            <Minus onClick={() => setQuantityCartProduct(quantityCartProduct == 1 ? 1 : quantityCartProduct-1)}>-</Minus>
            <Plus onClick={() => setQuantityCartProduct(quantityCartProduct+1)}>+</Plus>
            </Box>
        </CardWrapper>
    )
}

export default Quantity